import { motion } from 'framer-motion'

export default function StepShell({
  eyebrow,
  title,
  description,
  children,
  variant = 'default',
  centered = true,
  contentTopClassName,
}) {
  const dense = variant === 'dense'
  const review = variant === 'review'
  const bigHeader = !dense
  const maxW = review ? 'max-w-3xl' : dense ? 'max-w-5xl' : 'max-w-3xl'
  const blockClass = `${maxW} ${centered ? 'mx-auto w-full text-center' : ''}`.trim()
  const contentTopMargin =
    contentTopClassName ??
    (dense ? 'mt-4 sm:mt-5' : review ? 'mt-5 sm:mt-6' : 'mt-10')
  return (
    <motion.div
      key={title}
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -18 }}
      transition={{ duration: 0.22, ease: 'easeOut' }}
      className="flex min-h-0 flex-col justify-start"
    >
      <div className={blockClass}>
        {eyebrow ? (
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#16c1b2]">{eyebrow}</p>
        ) : null}
        <h1
          className={
            bigHeader
              ? 'mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'
              : eyebrow
                ? 'mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl'
                : 'mt-4 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl'
          }
        >
          {title}
        </h1>
        {description ? (
          <p
            className={
              dense
                ? 'mt-1.5 text-sm text-gray-500 sm:text-base'
                : 'mt-3 text-base text-gray-500 sm:text-lg'
            }
          >
            {description}
          </p>
        ) : null}
      </div>
      <div
        className={`${blockClass} ${contentTopMargin} ${centered ? 'flex flex-col items-center' : ''}`.trim()}
      >
        {centered ? <div className="w-full">{children}</div> : children}
      </div>
    </motion.div>
  )
}
